import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE } from '../config';

export function useProjectTitle(): string | null {
  const params = useParams<{ projectId?: string }>();
  const { token } = useAuth();
  const [projectTitle, setProjectTitle] = useState<string | null>(null);

  useEffect(() => {
    const projectId = params.projectId;
    if (!token || !projectId || projectId === 'new') {
      setProjectTitle(null);
      return;
    }

    let cancelled = false;
    fetch(`${API_BASE}/api/projects/${projectId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled) {
          setProjectTitle(data?.title ?? null);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setProjectTitle(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [params.projectId, token]);

  useEffect(() => {
    const handleProjectTitleUpdate = (event: Event): void => {
      const customEvent = event as CustomEvent<{ projectId: string; title: string }>;
      if (customEvent.detail.projectId === params.projectId) {
        setProjectTitle(customEvent.detail.title);
      }
    };
    window.addEventListener('project-title-updated', handleProjectTitleUpdate);
    return () => window.removeEventListener('project-title-updated', handleProjectTitleUpdate);
  }, [params.projectId]);

  return projectTitle;
}
